<div class="root" *transloco="let t; read:'permit'">
    <div [innerHTML]="t('noAccess')"></div>
</div>
